/* ExpediCamp - wlasny JavaScript motywu.
   Ladowany z snippets/ec-head-styles.liquid (wpiete w layout/theme.liquid).
   Trzymamy go TU, a nie w plikach Dawn, zeby aktualizacje motywu go nie nadpisywaly. */

/* === Menu w stopce: rozwijane na mobile === */
(function () {
  function initFooterAccordion() {
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var columns = document.querySelectorAll('.footer .footer-block--menu');
    columns.forEach(function (col) {
      var heading = col.querySelector('.footer-block__heading');
      var content = col.querySelector('.footer-block__details-content');
      if (!heading || !content || col.dataset.ecFooterInit) return;
      col.dataset.ecFooterInit = '1';
      col.classList.add('footer-block--collapsible');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', 'false');
      function toggle() {
        if (!mqMobile.matches) return;
        var open = col.classList.toggle('is-open');
        heading.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', function () {
        if (mqMobile.matches) return;
        document.querySelectorAll('.footer .footer-block--collapsible.is-open').forEach(function (col) {
          col.classList.remove('is-open');
          var h = col.querySelector('.footer-block__heading');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();

/* === Size Chart do wiersza etykiety "Size" (ExpediCamp) ===
   Przycisk miarki jest w kodzie osobnym blokiem ZA selektorem wariantow.
   Wkladamy go DO elementu <legend class="form__label">, a CSS ustawia wiersz
   jako flex ze spacingiem, wiec "Size" jest po lewej, a miarka po prawej.
   Dawn podmienia <variant-selects> przy zmianie wariantu, wiec obserwujemy DOM
   i w razie potrzeby wstawiamy przycisk ponownie. */
(function () {
  var saved = null;

  function place() {
    try {
      var pill = document.querySelector('.product__info-container .product-form__input--pill');
      if (!pill) return;
      var legend = pill.querySelector('.form__label');
      if (!legend) return;
      var opener =
        legend.querySelector('.product-popup-modal__opener') ||
        pill.querySelector('.product-popup-modal__opener') ||
        document.querySelector('.product__info-container .product-popup-modal__opener') ||
        saved;
      if (!opener) return;
      saved = opener;
      if (opener.parentNode !== legend) {
        legend.appendChild(opener);
      }
      pill.classList.add('ec-has-size-chart');
    } catch (e) {
      /* nie blokujemy strony, gdyby cokolwiek poszlo nie tak */
    }
  }

  function init() {
    place();
    var root = document.querySelector('.product__info-container');
    if (!root || !window.MutationObserver) return;
    new MutationObserver(function () { place(); }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === Plakietka zaufania na kolekcjach (ExpediCamp) ===
   Owija wiodace gwiazdki w opisie kolekcji w <span class="ec-stars">,
   zeby CSS mogl pokolorowac same gwiazdki na bursztynowo, a tekst zostawic szary.
   Robimy to skryptem, a nie w tresci opisu, bo dzieki temu dziala na KAZDEJ
   kolekcji - takze tych, ktorych nie da sie edytowac przez API, i na przyszlych. */
(function () {
  function styleBadge() {
    try {
      var el = document.querySelector('.collection-hero__description');
      if (!el || el.dataset.ecBadge) return;
      var html = el.innerHTML;
      var out = html.replace(/(★+)/, '<span class="ec-stars">$1</span>');
      if (out === html) return;
      el.innerHTML = out;
      el.dataset.ecBadge = '1';
      el.classList.add('ec-badge');
    } catch (e) {
      /* nie blokujemy strony */
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleBadge);
  } else {
    styleBadge();
  }
})();
